/**
 * Initialisiert Supernova-Effekt-Module und verdrahtet sie.
 * Ausgelagert aus main.ts um die 200-Zeilen-Grenze einzuhalten.
 */

import type { Engine } from '../core/Engine';
import type { RenderPipeline } from '../renderer/RenderPipeline';
import { SupernovaDebrisRenderer } from '../objects/SupernovaDebrisRenderer';

/** Registriert den Supernova-Debris-Renderer. */
export function setupSupernovaEffects(
  engine: Engine,
  pipeline: RenderPipeline,
  hexRadius: number,
): void {
  const debris = new SupernovaDebrisRenderer(hexRadius);
  engine.register(debris);
  pipeline.addRenderable(debris);
}
